import React, { useState, useCallback, useMemo } from 'react';
import ContributionItem from './ContributionItem';

const romanNumerals = ["I", "II", "III", "IV", "V", "VI"];
const alphabet = ['a', 'b', 'c', 'd'];

const AllContainers = React.memo(({ contributions, onShowPodium, type, parties, sousparties }) => {
  const [expandedItems, setExpandedItems] = useState(new Set());

  const toggleExpanded = useCallback((index) => {
    setExpandedItems(prev => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  }, []);

  const getPrefix = useCallback((index) => {
    if (type === 'plan' && parties != null && sousparties != null) {
      const partieIndex = Math.floor(index / (sousparties + 1));
      const souspartieIndex = index % (sousparties + 1);
      if (souspartieIndex === 0) {
        return romanNumerals[partieIndex] || String(partieIndex + 1);
      }
      return alphabet[souspartieIndex - 1] || String.fromCharCode(96 + souspartieIndex);
    }
    return (index + 1);
  }, [type, parties, sousparties]);

  const contributionItems = useMemo(() => {
    return contributions.map((phaseContent, index) => {
      const isMainPart = type === 'plan' && index % (sousparties + 1) === 0;
      
      return (
        <ContributionItem
          key={index}
          contributionData={phaseContent}
          prefix={getPrefix(index)}
          isMainPart={isMainPart}
          isExpanded={expandedItems.has(index)}
          onToggleExpand={() => toggleExpanded(index)}
          onShowPodium={onShowPodium}
        />
      );
    });
  }, [contributions, type, sousparties, expandedItems, getPrefix, toggleExpanded, onShowPodium]);

  return (
    <div className="space-y-3">
      {contributionItems}
    </div>
  );
}, (prevProps, nextProps) => {
  return JSON.stringify(prevProps.contributions) === JSON.stringify(nextProps.contributions) &&
         prevProps.type === nextProps.type &&
         prevProps.parties === nextProps.parties &&
         prevProps.sousparties === nextProps.sousparties;
});

AllContainers.displayName = 'AllContainers';

export default AllContainers;